import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "digitalzone-detail" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","margin-bottom":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "任务时间：", -1)

import { ref, computed } from 'vue';
import {
  BaseTable,
  BaseSelect,
  BaseTableProps,
  useTableColumn
} from 'xrk-components';
import { selectMonthTask, taskRecordDetail } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'digitalzone-detail',
  props: {
    projectId: { default: null },
    projectType: { default: null },
    id: { default: null },
    dataState: {}
  },
  setup(__props: any) {

const props = __props;
const month = ref(null);
const tableData = ref([]);
const titleList = ref([]);

const userName = ref('');
const monthList = ref([]);

const onChangeMonth = async () => {
  const { data } = await selectMonthTask({
    userId: userId.value,
    projectId: props.projectId,
    month: month.value
  });

  // 处理 uvList 数据
  const uvList = data.uvList;
  const tableDataList = [];
  uvList.forEach(item => {
    const tableRow = {};
    item.forEach(citem => {
      tableRow[citem.date] = citem.uv;
    });
    tableDataList.push(tableRow);
  });
  // 生成表头
  titleList.value = data.titleList;
  // 生成表格数据
  tableData.value = tableDataList;
};

const userId = ref(null);
const getData = async () => {
  const { data: detail } = await taskRecordDetail({
    sceneType: props.projectType,
    id: props.id,
    dataState: props.dataState,
    projectId: props.projectId
  });
  userName.value = detail.username;
  monthList.value = detail.monthList.map(item => {
    return {
      value: item,
      label: item
    };
  });
  month.value = monthList.value[0].value;
  userId.value = detail.userId;
  onChangeMonth();
};

const columns = computed<BaseTableProps['columns']>(() => {
  return titleList.value.map(item => {
    return useTableColumn({
      label: item,
      prop: item
    });
  });
});

getData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "终端服务人员：" + _toDisplayString(userName.value), 1),
      _hoisted_3,
      (monthList.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(BaseSelect), {
            key: 0,
            modelValue: month.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
            onChange: onChangeMonth,
            style: {"width":"200px"},
            options: monthList.value
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(BaseTable), {
      columns: columns.value,
      data: tableData.value
    }, null, 8, ["columns", "data"])
  ]))
}
}

})